import { Store } from '@ngxs/store';
import { Observable, combineLatest } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';
import { IMenuFilter } from '@nimbus-library/features/menu';
import { TeamState } from '@nimbus-portal/common/store/teams/teams.state';
import { ProvisioningSettingsState } from '@nimbus-global/features/settings/store/provisioning-settings/provisioning-settings.state';
import { ProvisioningTeamStatusAnswer } from '@nimbus-global/features/settings/models/provisioning-settings/i-provisioning-team-status.enum';
import { SelectedTeamState } from '@nimbus-global/features/shared/store/selected-team-state/selected-team.state';

export class ProvisioningFilter implements IMenuFilter<ProvisioningTeamStatusAnswer[]> {
  public constructor(private readonly store: Store) {}

  public static for(statuses: ProvisioningTeamStatusAnswer[]): {
    type: typeof ProvisioningFilter;
    option: ProvisioningTeamStatusAnswer[];
  } {
    return { type: ProvisioningFilter, option: statuses };
  }

  public validate$(options: ProvisioningTeamStatusAnswer[]): Observable<boolean> {
    return combineLatest([
      this.store.select(SelectedTeamState.team),
      this.store.select(TeamState.context).pipe(skipWhile((context) => !context)),
      this.store.select(ProvisioningSettingsState.givenTeamStatus),
    ]).pipe(
      map(([team, _context, status]) => {
        if (!team || !team.groupId || team.groupId === '') {
          return true;
        }

        return options.some((answer) => status === answer);
      }),
    );
  }
}
